// ============================================================================
// Branding ตาม domain (runtime) — build เดียวเสิร์ฟได้หลาย domain
// เลือก logo / ชื่อแอป / สี primary ตาม window.location.hostname
//
// วิธีเพิ่ม/แก้แบรนด์: แก้ array BRANDS ด้านล่าง (match = คำที่อยู่ใน hostname)
// ============================================================================

const BRANDS = [
  {
    key: 'jinmatai',
    branchId: 2, // BranchID ฝั่ง backend
    match: ['jinmatai'], // hostname (production) ที่มีคำนี้ => ใช้แบรนด์นี้
    ports: ['8080'], // dev: localhost:8080 => jinmatai
    appName: 'JINMATAICARGO',
    telegramBot: 'Jinmatai_Bot', // username บอท (ไม่มี @) ต้อง /setdomain ที่ BotFather ให้ตรง domain นี้
    // eslint-disable-next-line global-require
    logo: require('@/assets/logo-jinmatai/jinmatai-logo.png'),
    primary: '#0079b3', // = $navy เดิม
  },
  {
    key: 'taobao2you',
    branchId: 1, // BranchID ฝั่ง backend
    match: ['taobao2you'],
    ports: [],
    appName: 'TAOBAO2YOU',
    telegramBot: 'Taobao2you_Bot',
    // eslint-disable-next-line global-require
    logo: require('@/assets/logo-taobao/t2y-new-logo.png'),
    primary: '#7367f0', // TODO: ยืนยันสี primary จริงของ taobao2you
  },
  {
    key: 'routeCargo',
    branchId: 3, // BranchID ฝั่ง backend
    match: ['routecargo'], // production hostname (เทียบแบบ lowercase)
    ports: ['8081'], // dev: localhost:8081 => routeCargo
    appName: 'ROUTECARGO',
    telegramBot: '', // TODO: ยังไม่ได้สร้างบอทของ routeCargo (ว่างไว้ = ซ่อนปุ่มเชื่อมต่อ)
    // eslint-disable-next-line global-require
    logo: require('@/assets/logo-jinmatai/routeCargo-logo.png'),
    primary: '#c10000',
  },
]

// แบรนด์เริ่มต้น เมื่อ hostname ไม่ตรงอันไหนเลย (เช่น localhost / IP / preview)
const DEFAULT_BRAND = BRANDS[0]

export function getBrand() {
  const loc = typeof window !== 'undefined' ? window.location : { hostname: '', port: '' }
  const host = (loc.hostname || '').toLowerCase()
  const port = loc.port || ''
  return (
    // production: เทียบจากชื่อ domain ก่อน
    BRANDS.find(b => (b.match || []).some(m => host.includes(m.toLowerCase())))
    // dev (localhost): เทียบจาก port
    || BRANDS.find(b => (b.ports || []).includes(port))
    || DEFAULT_BRAND
  )
}

// BranchID ของแบรนด์ปัจจุบัน (ใช้ส่งให้ API ที่ต้องการ branchId)
export function getBranchId() {
  return getBrand().branchId
}

// username ของ Telegram bot ประจำแบรนด์ ('' = ยังไม่ได้ตั้งค่า)
export function getTelegramBot() {
  return getBrand().telegramBot || ''
}

// ปรับเฉดสี (percent < 0 = เข้มขึ้น, > 0 = สว่างขึ้น) ใช้กับ state hover/active
function shade(hex, percent) {
  const h = hex.replace('#', '')
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h
  const num = parseInt(full, 16)
  const t = percent < 0 ? 0 : 255
  const p = Math.abs(percent) / 100
  const r = Math.round((t - ((num >> 16) & 0xff)) * p) + ((num >> 16) & 0xff)
  const g = Math.round((t - ((num >> 8) & 0xff)) * p) + ((num >> 8) & 0xff)
  const b = Math.round((t - (num & 0xff)) * p) + (num & 0xff)
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
}

function rgba(hex, a) {
  const h = hex.replace('#', '')
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h
  const num = parseInt(full, 16)
  return `rgba(${(num >> 16) & 0xff}, ${(num >> 8) & 0xff}, ${num & 0xff}, ${a})`
}

// inject <style> ทับสี primary ที่ถูก compile ฝังเป็นค่าตายตัวตอน build
// เรียกตอนแอปบูต (ก่อน App.vue อ่าน CSS var --primary)
export function applyBrandTheme(brand = getBrand()) {
  const c = brand.primary
  const dark = shade(c, -15)
  const css = `
:root { --primary: ${c}; }
.btn-primary, .btn-primary.disabled, .btn-primary:disabled { background-color: ${c} !important; border-color: ${c} !important; }
.btn-primary:hover:not(.disabled):not(:disabled), .btn-primary:focus, .btn-primary:active, .btn-primary.active { background-color: ${dark} !important; border-color: ${dark} !important; }
.btn-outline-primary { color: ${c} !important; border-color: ${c} !important; }
.btn-outline-primary:hover, .btn-outline-primary:active, .btn-outline-primary:focus { background-color: ${c} !important; color: #fff !important; }
.btn-flat-primary { color: ${c} !important; }
.btn-flat-primary:hover, .btn-flat-primary:active, .btn-flat-primary:focus { background-color: ${rgba(c, 0.12)} !important; color: ${c} !important; }
.bg-primary { background-color: ${c} !important; }
.text-primary { color: ${c} !important; }
.border-primary { border-color: ${c} !important; }
.badge-primary { background-color: ${c} !important; }
.badge-light-primary { color: ${c} !important; background-color: ${rgba(c, 0.12)} !important; }
.alert-primary { color: ${c} !important; background-color: ${rgba(c, 0.12)} !important; }
a { color: ${c}; }
.form-control:focus, .custom-select:focus { border-color: ${c} !important; }
.custom-control-primary .custom-control-input:checked ~ .custom-control-label::before,
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: ${c} !important; border-color: ${c} !important; box-shadow: 0 2px 4px 0 ${rgba(c, 0.4)} !important;
}
.main-menu.menu-light .navigation > li.active > a,
.main-menu.menu-light .navigation > li ul .active {
  background: linear-gradient(118deg, ${c}, ${rgba(c, 0.7)}) !important;
  box-shadow: 0 0 10px 1px ${rgba(c, 0.7)} !important;
}
.nav-pills .nav-link.active { background-color: ${c} !important; box-shadow: 0 4px 18px -4px ${rgba(c, 0.65)} !important; }
.pagination .page-item.active .page-link { background-color: ${c} !important; }
.vs__dropdown-option--highlight { background-color: ${c} !important; }
`.trim()

  let el = document.getElementById('brand-theme-override')
  if (!el) {
    el = document.createElement('style')
    el.id = 'brand-theme-override'
    document.head.appendChild(el)
  }
  el.innerHTML = css
  document.title = brand.appName
  return brand
}
